import * as React from 'react';
import { SVGProps } from 'react';

const CalendarArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={10}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.506 8.03a1.487 1.487 0 0 1-.435 1.06l-6 5.971a1.508 1.508 0 0 1-1.641.325 1.507 1.507 0 0 1-.815-.811A1.492 1.492 0 0 1 .94 12.94L5.906 8.03l-4.77-4.926a1.493 1.493 0 0 1-.381-1.685A1.493 1.493 0 0 1 1.62.592a1.507 1.507 0 0 1 1.675.45l5.79 5.972c.265.273.415.636.42 1.015Z"
      fill="#569DE5"
    />
  </svg>
);

export default CalendarArrowRight;
